import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const badges = ['Instant Download', 'One-Time Payment', 'Lifetime Access', '7-Day Guarantee'];
const stats: {
  value: string;
  label: string;
}[] = [{
  value: '+250',
  label: 'CLINICAL PROTOCOLS'
}, {
  value: '7',
  label: 'DIAGNOSTIC STEPS'
}, {
  value: '+50',
  label: 'TOOLS & RESOURCES'
}, {
  value: '6',
  label: 'SPECIALIZED VOLUMES'
}];
export function Hero() {
  return <header className="w-full bg-navy-950 text-white" data-id="element-129" data-mp="ms7qxygh4dxp">
      <div className="mx-auto w-full max-w-5xl px-4 pb-10 pt-8 sm:px-6 sm:pb-14 sm:pt-12" data-id="element-130" data-mp="qukldqprspf6">
        <p className="text-center font-display text-lg font-bold tracking-[0.3em] text-gold-400" data-id="element-131" data-mp="vndo691ohnom">
          DR. KARITO
        </p>
        <p className="mt-2 text-center text-[11px] font-bold uppercase tracking-[0.2em] text-white/50" data-id="element-132" data-mp="10knleavb73n0">
          A Proven Clinical System for Dentists
        </p>

        <h1 className="mx-auto mt-6 max-w-3xl text-center font-display text-[32px] font-bold leading-[1.1] sm:text-5xl lg:text-[56px]" data-id="element-133" data-mp="1aitjsihwprn4">
          Structure the Diagnosis of{' '}
          <span className="italic text-gold-400" data-id="element-134" data-mp="4ozo0a0570jb">Any Dental Case</span> in 7 Steps
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-135" data-mp="3vur74pfi5cwm">
          Discover the system that helps you know exactly what to evaluate and what to
          prioritize… without spending hours trying to figure out what to do next.
        </p>

        <div className="mt-8" data-id="element-136" data-mp="nfhavxyan1wr">
          <img src="https://cdn.magicpatterns.com/uploads/jSmamDUVW5WWkpHcLeVft6/DIAGNOSTICO-EN.png" alt="Clinical Master System for Dental Diagnosis: 6-volume clinical library and 5 exclusive bonuses" className="mx-auto w-full max-w-[560px]" loading="eager" data-id="element-137" data-mp="ng8usbij3b77" />
        </div>

        <p className="mx-auto mt-4 max-w-xl text-center text-sm font-semibold text-gold-300" data-id="element-138" data-mp="1b6380u6rf1rz">
          Clinical Master System™ for Dental Diagnosis — 6-Volume Clinical Library + 5 Exclusive
          Bonuses
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-139" data-mp="35l0le26h0v8d">
          <CTAButton id="hero-cta" label="I want access to the system" data-id="element-140" data-mp="35jp5j3zr3x0w" />
        </div>

        <ul className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-141" data-mp="2qwvx8ionfri7">
          {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-[12px] font-medium text-white/65" data-id="element-142" data-mp="2vt4afqjadamq">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-143" data-mp="2hxsghlcyfo6v" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-t border-white/10 bg-navy-900" data-id="element-144" data-mp="27yjmwtm04bl1">
        <dl className="mx-auto grid w-full max-w-4xl grid-cols-2 gap-y-7 px-4 py-8 sm:grid-cols-4 sm:px-6" data-id="element-145" data-mp="2cvtb65xnmh7a">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center text-center" data-id="element-146" data-mp="66ep51htmk2e">
              <dt className="sr-only" data-id="element-147" data-mp="b3ophc6r0g50">{stat.label}</dt>
              <dd className="font-display text-3xl font-bold text-gold-400 sm:text-4xl" data-id="element-148" data-mp="1vmr32ca3txve">
                {stat.value}
              </dd>
              <p className="mt-1 px-2 text-[10px] font-bold uppercase leading-tight tracking-[0.12em] text-white/55" data-id="element-149" data-mp="1qoz2yuzb35g4">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </header>;
}